import {createAction, handleActions} from 'redux-actions';
import {takeLatest} from 'redux-saga/effects';

import createRequestSaga, {createRequestActionTypes} from '../api/createRequestSaga';
import * as authAPI from '../api/auth';
import {setCookie} from '../api/cookie';

// 액션 타입
const INITIALIZE = 'auth/INITIALIZE';

const [LOGIN, LOGIN_SUCCESS, LOGIN_FAILURE] = createRequestActionTypes('auth/LOGIN');

const [UPDATE_PASSWORD, UPDATE_PASSWORD_SUCCESS, UPDATE_PASSWORD_FAILURE] = createRequestActionTypes('auth/UPDATE_PASSWORD');

// 액션 생성 함수
export const initialize = createAction(INITIALIZE);

export const login = createAction(
    LOGIN,
    ({ userId, password }) => ({ userId, password })
);

export const updatePassword = createAction(
    UPDATE_PASSWORD,
    ({ userId, password, newPassword }) => ({ userId, password, newPassword })
);

// 사가 생성
const loginSaga = createRequestSaga(LOGIN, authAPI.login);

const updatePasswordSaga = createRequestSaga(UPDATE_PASSWORD, authAPI.updatePassword);

export function* authSaga() {
    yield takeLatest(LOGIN, loginSaga);
    yield takeLatest(UPDATE_PASSWORD, updatePasswordSaga);
}

const initialState = {
    auth: null,
    authError: null,
    updateResponse: null,
    updateError: null
};

const auth = handleActions(
    {
        [INITIALIZE]: () => (initialState),
        [LOGIN_SUCCESS]: (state, { payload: response }) => {
            const { token, name, isAdmin } = response.data;

            setCookie('accessToken', token, { path: '/' });
            setCookie('username', name, { path: '/' });
            setCookie('administrator', isAdmin, { path: '/' });

            return {
                ...state,
                auth: response.data,
                authError: null
            }
        },
        [LOGIN_FAILURE]: (state, {payload: error}) => ({
            ...state,
            auth: null,
            authError: error.response.data
        }),
        [UPDATE_PASSWORD_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            updateResponse: response,
            updateError: null
        }),
        [UPDATE_PASSWORD_FAILURE]: (state, { payload: error }) => ({
            ...state,
            updateResponse: null,
            updateError: error.response.data
        })
    },
    initialState
);

export default auth;
